export interface Category {
  slug: string;
  name: string;
  description: string;
  count: number;
  icon: string;
}

export const comicCategories: Category[] = [
  {
    slug: "ego",
    name: "恶搞",
    description: "最没下限的恶搞名场面，谁看了都得笑出声。",
    count: 42,
    icon: "ri-emotion-laugh-line",
  },
  {
    slug: "reversal",
    name: "反转",
    description: "开局一个普通设定，结尾直接天翻地覆。",
    count: 37,
    icon: "ri-sparkling-2-line",
  },
  {
    slug: "plot-twist",
    name: "神展开",
    description: "谁也猜不到下一秒发生什么，剧情狂飙。",
    count: 31,
    icon: "ri-aliens-line",
  },
  {
    slug: "brain-hole",
    name: "脑洞",
    description: "天马行空的奇思妙想，越看越上头。",
    count: 46,
    icon: "ri-lightbulb-flash-line",
  },
  {
    slug: "addictive",
    name: "魔性",
    description: "看完就停不下来，循环播放洗脑预警。",
    count: 29,
    icon: "ri-loop-right-line",
  },
  {
    slug: "hilarious",
    name: "爆笑",
    description: "全程高能无尿点，笑到肚子疼。",
    count: 52,
    icon: "ri-emotion-happy-line",
  },
];